var exports = {
  "kL": "xfd349460--b5a92f--container",
  "ZQ": "xfd349460--b5a92f--items-container",
  "AS": "xfd349460--b5a92f--item",
  "DD": "xfd349460--b5a92f--title",
};

module.exports = exports;
